module.exports = __webpack_public_path__ + "static/media/party.47c343b2.svg";